import { klubbleAPI, ApiResult } from 'client/api/common'
import { EntitySettings } from 'client/hooks/useConfig'

type QrGameResponse = ApiResult<{
  startPuzzleResponse: {
    externalPuzzleId: string
    klubblePuzzleId: number
    puzzleTypeNameKey: string
    puzzleTypeId: string
  }
  shareLink: {
    shareLinkShortUrl: string
    shareLink: string
  }
}>

const getQRGameForLocation = async (locationGuid: string, puzzlesClientId: EntitySettings['puzzlesClientId']) => {
  const { data: response } = await klubbleAPI.post<QrGameResponse>(`Puzzle/getCurrentGameForLocation?locationGuid=${locationGuid}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (!response.success) {
    throw new Error(response.message)
  } else {
    const {
      externalPuzzleId, klubblePuzzleId, puzzleTypeNameKey, puzzleTypeId,
    } = response.data.startPuzzleResponse
    const {
      shareLink,
    } = response.data.shareLink

    const playerParams = {
      gametype: puzzleTypeNameKey,
      puzzleid: externalPuzzleId,
      customerid: puzzlesClientId,
      klubblePuzzleId: `${klubblePuzzleId}`,
      puzzleTypeId,
    }

    return { shareLink, playerParams }
  }
}

export default getQRGameForLocation
